export default __webpack_public_path__ + "static/brandinggraphic-bdb787f6b438d40bd83736c514069780.png";